import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { authed as isAuthed } from '../features/login/loginSlice';
import ErrorBoundary from '../components/ErrorBoundary';

export default function FullLayout() {
  const authed = useSelector(isAuthed);
  const navigate = useNavigate();

  useEffect(() => {
    if (!authed) {
      navigate('/login');
    }
  }, [authed]);

  return (
    <ErrorBoundary>
      <Box sx={{ display: 'flex' }}>
        <Navbar />
        { authed && <Outlet /> }
      </Box>
    </ErrorBoundary>
  );
}
